<template>
  <div class="auth-select">
    <div class="single-select" v-for="(item, index) in ProAuthList" :key="'single-select-' + index">
      <Checkbox v-model="item.checked" @on-change="changeSelect($event, index)">{{item.nameEn}}</Checkbox>
      <div class="auth-upload" :class="{disable: !item.checked}">
        <upload
          :ref="'select-upload-' + index"
          :config="uploadBannerConfig"
          :fileList="item.fileList"
          @upload-ok="bannerOK($event, index)"
          v-if="item.isNeedFile && item.checked"
        />
        <div class="auth-upload-modal"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import upload from "@components/En/upLoad2/upLoad2";

export default {
  name: "auth-select",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    Modal: {
      type: Array,
      default: function() {
        return [];
      }
    },
    type: {
      type: Number,
      default: 1
    }
  },
  components: {
    upload
  },
  data() {
    return {
      ProAuthList: [],
      Authentication: [],
      select: [],
      single: "",

      config: {
        uploadTxt: "证书",
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        remind: " ",
        limitNum: 1
      }
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    }),
    uploadBannerConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_1";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
    option() {
      return { compId: this.company.id, pageSize: 1000 };
    }
  },
  created() {
    this.init();
  },
  watch: {
    Modal(val, oldVal) {
      console.log(val);
      const valStr = JSON.stringify(val);
      const oldValStr = JSON.stringify(oldVal);
      if (valStr !== oldValStr) {
        this.init();
      }
    }
  },
  methods: {
    ...mapActions({
      getProAuth: "companyInfoModule/getProAuth", // 获取产品标签
      getProQualities: "companyInfoModule/getProQualities", // 获取质量体系认证标签
    }),
    async init() {
      let reqData = [];
      if (this.type == 1) {
        reqData = await this.getProAuth();
      }
      if (this.type == 2) {
        reqData = await this.getProQualities();
      }
      if (reqData.length) {
        reqData.map(c => {
          c.checked = false;
          c.FilePath = "";
          c.fileList = [];
        });
      }
      const copyData = JSON.parse(JSON.stringify(this.Modal));
      if (this.Modal && this.Modal[0]) {
        this.Modal.forEach(c => {
          reqData.map(v => { 
            if (c.Name === v.name && c.FilePath) {
              v.checked = true;
              v.FilePath = c.FilePath;
              v.fileList = [c.FilePath];
            }
          });
        });
      }
      this.ProAuthList = reqData; 
      this.send();
    },
    send() {
      let arr = []; // modal 数据
      let errorTxt = ""; // 错误提示
      let arrLen = 0;
      this.ProAuthList.forEach((c, i) => {
        if (c.checked) {
          arrLen += 1;
        }
        if (c.checked && c.isNeedFile && !c.FilePath) {
          errorTxt = `请上传${c.name}的认证文件`; 
        }
        arr.push({
          Id: c.id,
          Name: c.name,
          FilePath: c.FilePath, 
        });
      });
      if (arrLen === 0 && this.type == 1 && this.ProAuthList.length > 0) {
        errorTxt = "Product certification options cannot be empty";
      }

      this.$emit("sendModal", arr);
      this.$emit("auth", errorTxt);
    },
    bannerOK(list, index) {
      this.uploadBanner = list;
      this.ProAuthList[index].FilePath = list[0] || "";

      this.send();
    },
    changeSelect(e, index) { 
      this.send();
    }
  }
};
</script>

<style scoped lang="scss">
.auth-select {
  display: flex;
  flex-wrap: wrap;
  width: 512px;
  .single-select {
    // width: 128px;
    margin-right: 10px;
  }
  .auth-upload {
    width: 100px;
    position: relative;
    &.disable {
      .auth-upload-modal {
        display: block;
      }
    }
    &-modal {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0.2;
      z-index: 2;
    }
  }
}
</style>

